import { h } from "preact";
function Divider() {
    return h("hr", { class: "m-hr" });
}
export default Divider;
